module.exports = __webpack_public_path__ + "static/bench-mv-dbfa5813d4b1dcc72f946635f23b5840.jpg";